import { Component } from '@angular/core';
import { BitfPaginatorComponent } from '../bitf-paginator.component';

@Component({
  selector: 'bitf-mat-paginator',
  templateUrl: './bitf-mat-paginator.component.html',
  styleUrls: ['./bitf-mat-paginator.component.scss'],
})
export class BitfMatPaginatorComponent extends BitfPaginatorComponent {}
